<template>
	<div class="select-color swap-colors">
		<span class="select-color__text text--grey-dark">{{ $t('common.shared.color.choose') }}</span>
		<div
			v-for="(c) in setup.colorOptions"
			:key="c.id"
			:tabindex="0"
			class="select-color__custom-color-select"
			:class="[
				`background--${c.name}`,
				`select-color__custom-color-select--${c.name}`,
				{ 'select-color__custom-color-select--selected' : c.id === setup.color?.id },
				{ 'select-color__custom-color-select--disabled' : disabled },
			]"
			@click="setup.selectColor(c)"
			@keyup.enter="setup.selectColor(c)">
			<o-icon
				v-show="c.id === setup.color?.id"
				icon="check"/>
		</div>
	</div>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedSelectColorEmits, SharedSelectColorProps } from './SharedSelectColorSetup';
import SharedSelectColorSetup from './SharedSelectColorSetup';
const emits = defineEmits<SharedSelectColorEmits>() as SharedSelectColorEmits;
const props = withDefaults(defineProps<SharedSelectColorProps>(), SharedSelectColorSetup.defaultProps);
const setup = new SharedSelectColorSetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
@import "@/styles/variables.less";

.select-color {
	display: flex;
	gap: 0.5rem;

	&__text {
		white-space: nowrap;
	}

	&__custom-color-select {
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 1rem;
		height: 1rem;
		border-radius: 0.2rem;
		background: var(--grey-light);
		transition: transform 0.2s;

		&::after {
			content: "";
			bottom: 0;
			transition: bottom 0.2s;
		}

		&:hover:not(.select-color__custom-color-select--selected) {
			transform: scale(1.2);
		}

		.orion-icon {
			font-size: 0.5rem;
			color: white;
		}

		&--selected {
			position: relative;
			transform: translateY(-0.3rem);

			&::after {
				content: "";
				position: absolute;
				bottom: -0.4rem;
				width: 100%;
				height: 0.13rem;
				background: inherit;
			}
		}

		&--disabled {
			pointer-events: none;

			&:not(.select-color__custom-color-select--selected) {
				opacity: 0.5;
			}
		}
	}
}
</style>
